import React, { Component } from "react";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import Collapse from "@material-ui/core/Collapse";
import ExpandLess from "@material-ui/icons/ExpandLess";
import ExpandMore from "@material-ui/icons/ExpandMore";
import Drawer from "@material-ui/core/Drawer";
import { withStyles } from "@material-ui/core/styles";
import { Link } from "react-router-dom";
import "../../assets/scss/components/sidenav/index.scss";

import get from "lodash/get";

const _ = { get };

const styles = {
  links: {
    textDecoration: "none"
  }
};
class MenuBar extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  // this method sets the current state of a menu item i.e whether it is in expanded or collapsed or a collapsed state
  handleClick(item) {
    this.setState(prevState => ({ [item]: !prevState[item] }));
  }
  // if the menu item doesn't have any child, this method simply returns a clickable menu item that redirects to any location and if there is no child this method uses recursion to go until the last level of children and then returns the item by the first condition.
  handler(children) {
    // const { classes } = this.props;

    const language = window.localStorage.getItem("lang") || "en";

    const { state } = this;
    return children.map(subOption => {
      if (!subOption.pages) {
        return (
          <ListItem
            button
            key={_.get(subOption, `translations[${language}]`, _.get(subOption, `translations[${language}]`, subOption.displayName))}
            className="nav-item"
            onClick={this.props.handleToggleIcon}
          >
            <Link to={subOption.route} className="nav-link">
              <span className="icon d-none"></span>
              <span className="linkName"> {_.get(subOption, `translations[${language}]`, subOption.displayName)}</span>
            </Link>
          </ListItem>
        );
      }
      return (
        <div className="nav-collapse" key={_.get(subOption, `translations[${language}]`, subOption.displayName)}>
          <ListItem
            button
            onClick={() => this.handleClick(_.get(subOption, `translations[${language}]`, subOption.displayName))}
            className="nav-item"
          >
            <span className="nav-link w-100">
              <span className="nav-text linkName">{_.get(subOption, `translations[${language}]`, subOption.displayName)}</span>
              {state[_.get(subOption, `translations[${language}]`, subOption.displayName)] ? <ExpandLess /> : <ExpandMore />}
            </span>
          </ListItem>
          <Collapse
            in={state[_.get(subOption, `translations[${language}]`, subOption.displayName)]}
            timeout="auto"
            unmountOnExit
          >
            {this.handler(subOption.pages)}
          </Collapse>
        </div>
      );
    });
  }

  render() {
    const { classes, userPermissions } = this.props;
    return (
      <aside
        className={`aside-navbar position-fixed ${
          this.props.activeSidebar === true ? "aside-active" : " "
        }`}
      >
        <Drawer
          variant="persistent"
          anchor="left"
          open
          classes={{ paper: classes.list }}
        >
          <div>
            <List>{this.handler(userPermissions)}</List>
          </div>
        </Drawer>
      </aside>
    );
  }
}
export default withStyles(styles)(MenuBar);
